import DryBeansProduct from 'models/DryBeansProduct'

export const packagingInitialState = {
  category: DryBeansProduct.category,
  subCategory: DryBeansProduct.subCategory,
  BeanPeaLentilType: {
    value: '',
    label: 'Type',
  },
  BeanPeaLentilSize: '',
}

export const beanTypeOptions = [
  {
    value: '',
    label: 'Type',
    isDisabled: true,
  },
  {
    value: 'Beans',
    label: 'Beans',
  },
  {
    value: 'Peas',
    label: 'Peas',
  },
  {
    value: 'Lentils',
    label: 'Lentils',
  },
]

export const sizeOptions = [
  {
    value: '',
    label: 'Size',
    isDisabled: true,
  },
  {
    value: '16 oz',
    label: '16 oz',
  },
  {
    value: '32 oz',
    label: '32 oz',
  },
  {
    value: '64 oz',
    label: '64 oz',
  },
]
